import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import PropTypes, { object, string, func, bool, number } from 'prop-types'
import { createSession } from '~/states/modules/analytics'
import VirtualAssistant from '~/components/virtualAssistent'
import api from '~/services/api'
import { errorMessage } from '~/services/messager'

const HeaderButtons = ({
	id,
	history,
	infos,
	onDownload,
	onUpdate,
	textUpdate,
	text,
	loadingVersion,
	hasContextAi,
}) => {
	const { versions, text_type, sent } = infos
	const dispatch = useDispatch()

	const { documentDetail } = useSelector(({ contextAi }) => contextAi)

	const [loadingPreviousMessages, setloadingPreviousMessages] = useState(false)
	const [previousMessages, setPreviousMessages] = useState(null)
	const [isAssistantOpen, setIsAssistantOpen] = useState(false)

	const handleEdit = () => {
		dispatch(createSession('edit'))
		history.push({
			pathname: `/documents/${id}/edit`,
			state: { current: 0 },
		})
	}

	// check if document is 'txt' and then see if user edit it directly on ckeditor
	// if that's true, the document can't be editable
	const [isEditable, setIsEditable] = useState(false)

	useEffect(() => {
		if (versions && text_type === '.txt') {
			const editable = !versions.some(
				(version) => version.only_updated_variables === undefined
			)

			setIsEditable(editable)
		}

		if (text_type === '.docx') setIsEditable(true)
		if (text_type === 'upload') setIsEditable(true)
	}, [versions, setIsEditable, text_type])

	// check if document is ready for create an new version when user type directly on ckeditor
	const [isUpdatable, setIsUpdatable] = useState(false)

	useEffect(() => {
		if (text_type === '.txt') {
			if (text !== textUpdate.text) {
				setIsUpdatable(true)
			} else {
				setIsUpdatable(false)
			}
		}
	}, [text_type, setIsUpdatable, text, textUpdate])

	// Se o chat da assistente estiver aberto, esconde o chatwoot button
	useEffect(() => {
		if (
			window.$chatwoot &&
			typeof window.$chatwoot.toggleBubbleVisibility === 'function'
		) {
			const visibility = isAssistantOpen ? 'hide' : 'show'
			try {
				window.$chatwoot.toggleBubbleVisibility(visibility)
			} catch (error) {
				console.log('Chatwoot widget not ready to be toggled yet.', error)
			}
		}
	}, [isAssistantOpen])

	const openAssistant = () => {
		if (previousMessages === null) {
			if (Object.keys(documentDetail).includes(`${id}`)) {
				const payload = {
					thread_id: documentDetail[`${id}`],
				}
				setloadingPreviousMessages(true)
				api
					.post('/ai/', payload)
					.then((response) => {
						setloadingPreviousMessages(false)
						const data = response.data
						setPreviousMessages(data.answer)
					})
					.catch((error) => {
						setloadingPreviousMessages(false)
						errorMessage({
							content:
								'Houve um erro na comunicação com o CHatGPT. \n Por favor, tente novamente mais tarde.',
						})
					})
			}
		}
		setIsAssistantOpen(true)
	}

	const closeAssistant = () => {
		setIsAssistantOpen(false)
	}

	const exportText = (text) => {
		console.log('Exporting text:', text)
	}

	return (
		<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 15 }}>
			<Button onClick={handleEdit} disabled={sent || !isEditable}>
				Editar Informações
			</Button>
			{text_type === '.txt' && (
				<Button
					disabled={sent || loadingVersion || !isUpdatable}
					onClick={() => onUpdate(textUpdate)}>
					Salvar modificações
				</Button>
			)}
			<Button onClick={onDownload}>Baixar Documento</Button>
			{(text_type === 'upload' || hasContextAi) && (
				<Button onClick={openAssistant}>Assistente Virtual</Button>
			)}
			<VirtualAssistant
				open={isAssistantOpen}
				onClose={closeAssistant}
				exportText={exportText}
				loadingPreviousMessages={loadingPreviousMessages}
				previousMessages={previousMessages}
				doc_type={'documentDetail'}
			/>
		</div>
	)
}

export default HeaderButtons

HeaderButtons.propTypes = {
	id: PropTypes.oneOfType([number, string]),
	history: object,
	infos: object,
	onDownload: func,
	onUpdate: func,
	textUpdate: object,
	text: string,
	loadingVersion: bool,
	hasContextAi: bool,
}
